import React from 'react';
import styled from "styled-components"
import SEO from '../../Components/SEO';

const ErrorContainer = styled.div`
    width: 100%;
    display:flex;
    flex-direction:column;
    height : 96vh;
    align-items:center;
    justify-content: center;
`

const ErrorTitle = styled.h1`
    font-size: 90px;
    color:grey;
`

const Desc = styled.p`
    font-size:13px
`
function Error(){
    return(
        <div>
            <SEO title={'404'} description={'Page non trouvée'} noindex={true} />
            <ErrorContainer>
                <ErrorTitle> 404 </ErrorTitle>
                <Desc> Oups ... Quelque chose a mal tourné, retournez à la page d&apos;accueil </Desc>
            </ErrorContainer>
            
        </div>
    )
}

export default Error